import { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 30000;

const TIER_ICON = {
  'DIVINE BASE BUILDER': '🕉️',
  'SUPER BASE BUILDER': '👑',
  'VVIP BASE BUILDER': '💎',
  'VIP BASE BUILDER': '⭐',
  'BASE BUILDER': '🏛️',
};

const fmtAT = (n) => {
  const v = Number(n || 0);
  if (v >= 10000000) return `${(v / 10000000).toFixed(2)} Cr`;
  if (v >= 100000) return `${(v / 100000).toFixed(2)} L`;
  if (v >= 1000) return `${(v / 1000).toFixed(1)}K`;
  return String(v);
};

const showGoldenToast = (d) => {
  const icon = TIER_ICON[d.nameplate] || '🌟';
  toast.custom((t) => (
    <div
      data-testid="samadhan-live-toast"
      className={`${t.visible ? 'animate-in slide-in-from-right' : 'animate-out slide-out-to-right'} pointer-events-auto`}
      style={{
        background: 'linear-gradient(135deg, #78350f 0%, #b45309 40%, #fbbf24 100%)',
        border: '2px solid #fde68a',
        borderRadius: '14px',
        padding: '14px 18px',
        color: '#fff',
        minWidth: '300px',
        maxWidth: '360px',
        boxShadow: '0 12px 40px rgba(180, 83, 9, 0.5), 0 0 0 1px rgba(253, 230, 138, 0.3)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
      onClick={() => { window.location.href = '/samadhan'; toast.dismiss(t.id); }}
      role="button"
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{ fontSize: '32px', filter: 'drop-shadow(0 0 8px rgba(253,230,138,0.9))' }}>{icon}</div>
        <div style={{ flex: 1, lineHeight: 1.3 }}>
          <div style={{ fontSize: '11px', letterSpacing: '1.2px', color: '#fde68a', fontWeight: 700 }}>
            ✨ SAMADHAN CENTER · LIVE
          </div>
          <div style={{ fontSize: '15px', fontWeight: 800, marginTop: '2px' }}>
            {d.name} just became a
          </div>
          <div style={{ fontSize: '16px', fontWeight: 900, color: '#fef3c7', textShadow: '0 1px 2px rgba(0,0,0,0.4)' }}>
            {d.nameplate}!
          </div>
          <div style={{ fontSize: '12px', marginTop: '4px', color: '#fef9c3', opacity: 0.95 }}>
            Donated <b>{fmtAT(d.amount)} AT</b> · {d.pack_label}
          </div>
        </div>
      </div>
    </div>
  ), { duration: 8000, position: 'top-right' });
};

export default function SamadhanLiveToast() {
  const seenRef = useRef(new Set());
  const bootRef = useRef(true);

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/api/samadhan/recent-big-donations?minutes=10&limit=5`);
        if (!alive) return;
        const list = (data?.donations || []).slice().reverse(); // oldest first
        if (bootRef.current) {
          // First tick: mark existing as seen, don't spam on load
          list.forEach((d) => d?.id && seenRef.current.add(d.id));
          bootRef.current = false;
          return;
        }
        list.forEach((d) => {
          if (d?.id && !seenRef.current.has(d.id)) {
            seenRef.current.add(d.id);
            showGoldenToast(d);
          }
        });
      } catch (_) { /* silent */ }
    };
    poll();
    const t = setInterval(poll, POLL_MS);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return null;
}
